export const manageMyStoreAdsTabsConfig: Array<{
  key: Exclude<StatusList, 'promoted'>;
  label: string;
}> = [
  {key: 'pending', label: 'در انتظار تایید'},
  {key: 'published', label: 'منتشر شده'},
  {key: 'expired', label: 'منقضی شده'},
  {key: 'rejected', label: 'رد شده'},
];
